<template>
  <b-tooltip
    class="ui-tooltip"
    :style="{ '--icon-spacing': `${iconSpacing}px` }"
    :position="$media.mobile ? mobilePosition : position"
  >
    <b-tag class="ui-tooltip__icon has-background-grey-light has-text-white" :class="`ml-${iconSpacing}px`">?</b-tag>

    <template #content>
      <p class="is-size-6 has-text-grey has-text-weight-bold mb-2" v-if="label">{{ label }}</p>
      <div class="ui-tooltip__content">
        <slot name="tooltipContent">
          <p v-if="content" class="ui-tooltip__content">{{ content }}</p>
        </slot>
      </div>
    </template>
  </b-tooltip>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'is-left'
    },
    mobilePosition: {
      type: String,
      default: 'is-top'
    },
    iconSpacing: {
      type: Number,
      default: 4
    },
    content: String,
    label: String
  }
}
</script>

<style lang="scss">
.tag.ui-tooltip {
  &__icon {
    height: 16px;
    width: 16px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-weight: 700;
    cursor: default;
  }
}

.ui-tooltip {
  &__content {
    white-space: normal;
  }
}

.b-tooltip.is-primary {
  .tooltip-content {
    background-color: $white;
    border-radius: 0;
    padding: 18px 24px;
    color: $black-ter;
    box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.25);
    width: 220px;

    &:before {
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 6px solid transparent;
    }
  }

  &.is-left {
    .tooltip-content {
      right: calc(100% + 6px + var(--icon-spacing) / 2);
    }

    .tooltip-content:before {
      border-left-color: $white;
    }
  }

  &.is-right {
    .tooltip-content {
      left: calc(100% + 6px + var(--icon-spacing) / 2);
    }

    .tooltip-content:before {
      border-right-color: $white;
    }
  }

  &.is-top {
    .tooltip-content {
      bottom: calc(100% + 6px + var(--icon-spacing) / 2);
      left: calc(50% + var(--icon-spacing) / 2);
    }

    .tooltip-content:before {
      border-top-color: $white;
    }
  }
}

@include tablet {
  .b-tooltip.is-primary {
    .tooltip-content {
      width: 320px;
    }
  }
}
</style>
